import { render, staticRenderFns } from "./ReInputAmount.vue?vue&type=template&id=b01f317a&scoped=true"
import script from "./ReInputAmount.vue?vue&type=script&lang=js"
export * from "./ReInputAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01f317a",
  null
  
)

export default component.exports